import { ChangeEvent, FocusEvent, useCallback, useEffect } from 'react';

import { IIndexSignature } from '@selfserve/react-utils';
import { useCustomSearchParams } from '@selfserve/react-hooks';

import { StyledSearchInput } from '../ui/admin-styled-components';

interface Props {
  onChange: (search: string) => void;
  value: string;
}

export const AdminSearchInput = ({ onChange, value }: Props) => {
  const [query, setQuery] = useCustomSearchParams();

  useEffect(() => {
    if (query['search'] !== value) {
      onChange((query['search'] as string) || '');
    }
  }, [query['search']]);

  const handleSearchChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => onChange(event.target.value),
    []
  );

  const handleSearchBlur = useCallback(
    (event: FocusEvent<HTMLInputElement>) => {
      const { value = '' } = event.target;
      setQuery(
        (prevQuery) => {
          const newQuery: IIndexSignature<string> = {
            ...prevQuery,
            search: value,
          };
          if (!value) delete newQuery['search'];
          return newQuery;
        },
        { replace: true }
      );
    },
    [value, setQuery]
  );

  return (
    <StyledSearchInput
      autoFocus
      value={value}
      onBlur={handleSearchBlur}
      onChange={handleSearchChange}
    />
  );
};
